module.exports = __webpack_public_path__ + "static/media/poll-h_circle.2b093f73.svg";